module.exports = __webpack_public_path__ + "static/media/0-6.45af5100.svg";